import React from "react";
import classnames from "classnames";
import debounce from "debounce";
import bem from "easy-bem";

// import { Scrollbar } from 'react-scrollbars-custom';

const cn = bem("chronos-scroll-container");
export class ScrollContainer extends React.Component {
  constructor(props) {
    super(props);
    // console.log('ScrollContainer Props', props);
    const { debounce: customDebounce, scrollClassName, containerProps } = props;
    this.delay =
      customDebounce && Number.isInteger(customDebounce) ? customDebounce : 300;
    this.containerRef = React.createRef();
    this.handleScrollEnd = debounce(this.handleScrollEnd, this.delay);

    //Custom Scroll ClassName
    this.scrollClassName = scrollClassName
      ? scrollClassName
      : "chronos-scroll-component-dragging";

    this.containerProps = { ...containerProps };
    //Is the container scrolling? This includes inertial scrolling!
    this.isScrolling = false;

    //Is the scrolling started?
    this.isScrollStarted = false;

    //Is touch or mousedown active?
    this.isPressed = false;

    //Bind Callback
    this.getRef = this.getRef.bind(this);
    //Other bound callbacks
    this.scrollToLeft = this.scrollToLeft.bind(this);
    this.scrollToRight = this.scrollToRight.bind(this);
    this.scrollUp = this.scrollUp.bind(this);
    this.scrollDown = this.scrollDown.bind(this);
  }

  componentDidMount() {
    const { nativeMobileScroll, startFocused } = this.props;
    // const container =
    //   this.containerRef.current && this.containerRef.current.container
    //     ? this.containerRef.current.container
    //     : this.containerRef.current;
    // console.warn(container);
    const container = this.getElement();
    window.addEventListener("mouseup", this.handleMouseUp);
    window.addEventListener("mousemove", this.handleMouseMove);
    window.addEventListener("touchmove", this.handleTouchMove, {
      passive: false,
    });
    window.addEventListener("touchend", this.handleTouchEnd);

    //Fix for Chrome eventlistener binding
    container.addEventListener("touchstart", this.handleTouchStart, {
      passive: false,
    });
    container.addEventListener("mousedown", this.handleMouseDown, {
      passive: false,
    });

    if (nativeMobileScroll) {
      //Checks if the device is mobile after page load
      this.isMobile = this.isMobileDevice();

      //If the device is mobile, rerender to to change styles
      if (this.isMobile) {
        this.forceUpdate();
      }
    }

    //Set the initial container coordinates, if set.
    if (startFocused) {
      if (startFocused.x && Number.isInteger(startFocused.x)) {
        container.scrollLeft = startFocused.x;
      }
      if (startFocused.y && Number.isInteger(startFocused.y)) {
        container.scrollTop = startFocused.y;
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("mouseup", this.handleMouseUp);
    window.removeEventListener("mousemove", this.handleMouseMove);
    window.removeEventListener("touchmove", this.handleTouchMove);
    window.removeEventListener("touchend", this.handleTouchEnd);
  }

  getElement() {
    return this.containerRef.current && this.containerRef.current.container
      ? this.containerRef.current.container
      : this.containerRef.current;
  }

  isMobileDevice() {
    return (
      typeof window.orientation !== undefined ||
      navigator.userAgent.indexOf("IEMobile") !== -1
    );
  }

  isDraggable(target) {
    const ignoreElements = this.props.ignoreElements;

    if (ignoreElements) {
      const closest = target.closest(ignoreElements);
      return closest === null || closest.contains(this.getElement());
    } else {
      return true;
    }
  }

  isScrollable() {
    // const container = this.containerRef.current;
    const container = this.getElement();
    return (
      container &&
      (container.scrollWidth > container.clientWidth ||
        container.scrollHeight > container.clientHeight)
    );
  }

  handleScrollEnd = () => {
    this.isScrolling = false;
    if (!this.isPressed && this.isScrollStarted) {
      this.processEnd();
    }
  };

  handleScroll = (ev) => {
    // const container = this.containerRef.current;
    const container = this.getElement();

    //Ignore internal scrolls
    if (
      container.scrollLeft !== this.scrollLeft ||
      container.scrollTop !== this.scrollTop
    ) {
      this.isScrolling = true;
      this.processScroll(ev);
      this.handleScrollEnd();
    }
  };

  handleTouchStart = (ev) => {
    const { nativeMobileScroll } = this.props;
    if (this.isDraggable(ev.target)) {
      if (nativeMobileScroll && this.isScrolling) {
        this.isPressed = true;
      } else {
        const touch = ev.touches[0];
        this.processClick(ev, touch.clientX, touch.clientY);
        if (!nativeMobileScroll && this.props.stopPropagation) {
          ev.stopPropagation();
        }
      }
    }
  };

  handleTouchEnd = (ev) => {
    const { nativeMobileScroll } = this.props;
    if (this.isPressed) {
      if (this.isScrollStarted && (!this.isScrolling || !nativeMobileScroll)) {
        this.processEnd();
      } else {
        this.isPressed = false;
      }
      this.forceUpdate();
    }
  };

  handleTouchMove = (ev) => {
    const { nativeMobileScroll } = this.props;
    if (this.isPressed && (!nativeMobileScroll || !this.isMobile)) {
      const touch = ev.touches[0];
      if (touch) {
        this.processMove(ev, touch.clientX, touch.clientY);
      }
      ev.preventDefault();
      if (this.props.stopPropagation) {
        ev.stopPropagation();
      }
    }
  };

  handleMouseDown = (ev) => {
    if (this.isDraggable(ev.target) && this.isScrollable()) {
      // console.log('CLICK', ev);
      this.processClick(ev, ev.clientX, ev.clientY);
      ev.preventDefault();
      if (this.props.stopPropagation) {
        ev.stopPropagation();
      }
    }
  };

  handleMouseMove = (ev) => {
    if (this.isPressed) {
      this.processMove(ev, ev.clientX, ev.clientY);
      ev.preventDefault();
      if (this.props.stopPropagation) {
        ev.stopPropagation();
      }
    }
  };

  handleMouseUp = (ev) => {
    if (this.isPressed) {
      if (this.isScrollStarted) {
        this.processEnd();
      } else {
        this.isPressed = false;
        this.forceUpdate();
        if (this.props.onClick) {
          this.props.onClick(ev);
        }
      }
      ev.preventDefault();
      if (this.props.stopPropagation) {
        ev.stopPropagation();
      }
    }
  };

  processClick(ev, clientX, clientY) {
    // const container = this.containerRef.current;
    const container = this.getElement();
    this.scrollLeft = container.scrollLeft;
    this.scrollTop = container.scrollTop;
    this.clientX = clientX;
    this.clientY = clientY;
    this.isPressed = true;
  }

  processStart(ev, changeCursor = true) {
    const { onScrollStart } = this.props;
    // const container = this.containerRef.current;
    const container = this.getElement();

    this.isScrollStarted = true;

    //Add the Class to change displayed cursor
    if (changeCursor) {
      document.body.classList.add(this.scrollClassName);
    }

    if (onScrollStart) {
      onScrollStart({
        scrollLeft: container.scrollLeft,
        scrollTop: container.scrollTop,
        scrollWidth: container.scrollWidth,
        scrollHeight: container.scrollHeight,
      });
    }
    this.forceUpdate();
  }

  processScroll(ev) {
    if (this.isScrollStarted) {
      const { onScroll, onScrollChange } = this.props;
      // const container = this.containerRef.current;
      const container = this.getElement();
      if (onScroll) {
        onScroll({
          scrollLeft: container.scrollLeft,
          scrollTop: container.scrollTop,
          scrollWidth: container.scrollWidth,
          scrollHeight: container.scrollHeight,
        });
      }
      if (onScrollChange) {
        onScrollChange({
          scrollLeft: container.scrollLeft,
          scrollTop: container.scrollTop,
          scrollWidth: container.scrollWidth,
          scrollHeight: container.scrollHeight,
        });
      }
    } else {
      this.processStart(ev, false);
    }
  }

  //Non-native scroll
  processMove(ev, newClientX, newClientY) {
    // console.log('Moving');
    const {
      horizontal,
      vertical,
      activationDistance,
      onScroll,
      onScrollChange,
    } = this.props;
    // const container = this.containerRef.current;
    const container = this.getElement();

    if (!this.isScrollStarted) {
      if (
        (horizontal &&
          Math.abs(newClientX - this.clientX) > activationDistance) ||
        (vertical && Math.abs(newClientY - this.clientY) > activationDistance)
      ) {
        this.clientX = newClientX;
        this.clientY = newClientY;
        this.processStart();
      }
    } else {
      if (horizontal) {
        container.scrollLeft -= newClientX - this.clientX;
      }
      if (vertical) {
        container.scrollTop -= newClientY - this.clientY;
      }
      if (onScroll) {
        onScroll({
          scrollLeft: container.scrollLeft,
          scrollTop: container.scrollTop,
          scrollWidth: container.scrollWidth,
          scrollHeight: container.scrollHeight,
        });
      }
      if (onScrollChange) {
        onScrollChange({
          scrollLeft: container.scrollLeft,
          scrollTop: container.scrollTop,
          scrollWidth: container.scrollWidth,
          scrollHeight: container.scrollHeight,
        });
      }
      this.clientX = newClientX;
      this.clientY = newClientY;
      this.scrollLeft = container.scrollLeft;
      this.scrollTop = container.scrollTop;
    }
  }

  processEnd(ev) {
    const { onScrollEnd } = this.props;
    // const container = this.containerRef.current;
    const container = this.getElement();

    this.isPressed = false;
    this.isScrollStarted = false;
    this.isScrolling = false;

    if (container && onScrollEnd) {
      onScrollEnd({
        scrollLeft: container.scrollLeft,
        scrollTop: container.scrollTop,
        scrollWidth: container.scrollWidth,
        scrollHeight: container.scrollHeight,
      });
    }
    document.body.classList.remove(this.scrollClassName);
    this.forceUpdate();
  }

  getRef(element) {
    [this.containerRef, this.props.innerRef].forEach((ref) => {
      if (ref) {
        if (typeof ref === "function") {
          ref(element);
        } else {
          ref.current = element;
        }
      }
    });
  }

  scrollToRight(amount, stepType = "px") {
    if (Number.isInteger(amount)) {
      if (!stepType || stepType.toLowerCase() === "px") {
        // const container = this.containerRef.current;
        const container = this.getElement();
        if (container.scrollLeft + container.style.width + amount > 0) {
          container.scrollLeft += amount;
          this.props.onScrollChange({
            scrollLeft: container.scrollLeft,
            scrollTop: container.scrollTop,
            scrollWidth: container.scrollWidth,
            scrollHeight: container.scrollHeight,
          });
        } else {
          console.log("Scroll Container would be invisible!");
        }
      }
    }
  }

  scrollToLeft(amount, stepType = "px") {
    if (Number.isInteger(amount)) {
      if (!stepType || stepType.toLowerCase() === "px") {
        // const container = this.containerRef.current;
        const container = this.getElement();
        container.scrollLeft -= amount;
        if (this.props.onScrollChange) {
          this.props.onScrollChange({
            scrollLeft: container.scrollLeft,
            scrollTop: container.scrollTop,
            scrollWidth: container.scrollWidth,
            scrollHeight: container.scrollHeight,
          });
        }
        // if (container.scrollLeft + amount < parentElement.offsetWidth) {
        //   console.log(
        //     'New left edge distance from parent start',
        //     container.scrollLeft - amount
        //   );
        //   container.scrollLeft -= amount;
        // } else {
        //   console.log(
        //     'Scroll Container would be invisible!',
        //     container.scrollLeft,
        //     parentElement.offsetWidth
        //   );
        // }
      }
    }
  }

  scrollUp(slots = 1) {
    const container = this.getElement();
    // const positionY =
    const el = container.firstChild.children[1].firstChild;
    // el.scrollTop -= slots * 140;
    el.scrollBy({
      top: -(slots * 140),
      behavior: "smooth",
    });
    // console.dir(el);
  }

  scrollDown(slots = 1) {
    const container = this.getElement();
    const el = container.firstChild.children[1].firstChild;
    // el.scrollTop += slots * 140;
    el.scrollBy({
      top: slots * 140,
      behavior: "smooth",
    });
  }

  //Used to set the position of the interior container by left edge
  setPosition(position) {
    if (Number.isInteger(position)) {
      // console.log('Setting Container position to', position);
      // const container = this.containerRef.current;
      const container = this.getElement();
      // console.dir(this);
      let newPosition;
      if (position >= 0) {
        container.scrollLeft = position;
        newPosition = position;
      } else {
        newPosition = this.props.innerWidth + position;
        container.scrollLeft = newPosition;
      }
      if (this.props.onScrollChange) {
        this.props.onScrollChange({
          scrollLeft: container.scrollLeft,
          scrollTop: container.scrollTop,
          scrollWidth: container.scrollWidth,
          scrollHeight: container.scrollHeight,
        });
      }
      return newPosition;
    }
  }

  render() {
    const {
      children,
      className,
      style,
      hideScrollbars,
      // parentElement,
      component: Component,
      // innerWidth,
      containerProps,
    } = this.props;

    return (
      <Component
        className={classnames(
          className,
          cn({
            dragging: this.isPressed,
            "hide-scrollbars": hideScrollbars,
            "native-scroll": this.isMobile,
          })
        )}
        {...containerProps}
        style={{ ...style }}
        ref={this.getRef}
        onScroll={this.handleScroll}
      >
        {children}
      </Component>
    );
  }
}
